import { HubspotCreditsHero } from '../../components/hubspot-credits/HubspotCreditsHero';
import { jsx as _jsx } from "react/jsx-runtime";
export const HubspotCreditsPage = () => {
  return /*#__PURE__*/_jsx(HubspotCreditsHero, {});
};